import api from './api.service';
import type { Company } from '@/types';

class CompanyService {
  async listCompanies(): Promise<Company[]> {
    const response = await api.get('/company/companies');
    const raw = (response as any)?.data?.data ?? (response as any)?.data;
    return Array.isArray(raw) ? raw : [];
  }

  async getById(id: string): Promise<Company> {
    const response = await api.get<Company>(`/company/companies/${id}`);
    const raw = (response as any)?.data ?? response;
    return raw?.data ?? raw;
  }

  async update(id: string, data: Partial<Company>): Promise<Company> {
    const response = await api.put<Company>(`/company/companies/${id}`, data);
    const raw = (response as any)?.data ?? response;
    return raw?.data ?? raw;
  }

  async listBranches(params?: { is_active?: boolean; search?: string }): Promise<
    Array<{ id: string; code: string; name: string; is_active?: boolean }>
  > {
    const response = await api.get('/company/branches', { params });
    const raw = (response as any)?.data?.data ?? (response as any)?.data;
    return Array.isArray(raw) ? raw : [];
  }
}

export default new CompanyService();
